import JobList from "./pages/ListPage.vue";
import JobDetail from "./pages/FormPage.vue";
import JobIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/job",
    component: JobIndex,
    redirect: "/job/list",
    name: "job",
    children: [
      {
        path: "list",
        component: JobList,
        name: "job.list",
      },
      {
        path: "create",
        component: JobDetail,
        name: "job.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: JobDetail,
        name: "job.edit",
        props: { create: false },
      },
    ],
  },
];
